import { ExperienceTemplateRenderer, TemplateComponent, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { UitkSpacing } from 'uitk-react-spacing';

export interface MainRegionProps extends TemplateComponentProps {
  templateComponent: TemplateComponent;
}

export const MainRegion: React.FC<MainRegionProps> = ({ templateComponent }) => {
  const { children } = templateComponent;

  if (!children || children.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary label="hotel.masterPage.main">
      <section data-stid="search-results__main" itemScope={true} itemType={'https://schema.org/Hotel'}>
        <UitkSpacing margin={{ small: { inline: 'three' }, medium: { inline: 'unset' } }}>
          <div>{children && <ExperienceTemplateRenderer templateComponents={children} />}</div>
        </UitkSpacing>
      </section>
    </ErrorBoundary>
  );
};
